import { ChangeDetectionStrategy, Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    selector: 'app-bom-copy-modal-content',
    templateUrl: './bom-copy-modal-content.component.html',
    styleUrls: ['./bom-copy-modal-content.component.scss'],
    standalone: false
})
export class BomCopyModalContentComponent {
  @Output() optionSelected = new EventEmitter<number>();
  @Input() selectedOption: number;

  selectOption(option) {
    this.optionSelected.emit(option);
  }
}
